import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { getModule } from 'store/actions/modules'
import { isServer } from 'utils'
import useContent from 'store/content'

import InputSelect from './Select'
import InputText from './Text'
import InputGetParameter from './GetParameter'

const Input = ({ id, displayType }) => {
  const content = useContent()
  const appId = content.get.appId()
  const currentInput = useSelector((store) => store.modules.input.list[id])
  const dispatch = useDispatch()

  useEffect(() => {
    if (!currentInput) {
      dispatch(getModule(appId, 'input', id))
    }
  }, [])

  // this is to ensure the inputs render with the cliend data
  if (isServer() || !currentInput) {
    return null
  }

  // displayType will overright inputType
  const getInput = () => {
    switch (displayType || currentInput.type) {
      case 'get-parameter':
        return <InputGetParameter input={currentInput} />
      case 'InputSelect':
        return <InputSelect input={currentInput} />
      case 'InputText':
        return <InputText input={currentInput} />
      case 'InputNumber':
        return <InputText type="number" input={currentInput} />
      default:
        return null
    }
  }

  return <>{getInput()}</>
}

Input.propTypes = {
  id: PropTypes.any,
  displayType: PropTypes.string,
}

export default Input
